// extracted by mini-css-extract-plugin
module.exports = {"lazy-image":"_-1SMH2A","lazy-image__loaded":"_-1NEV_h","lazy-image__loading":"_-1vayV1","lazy-image__failed":"_-3bwnpz"};